'use client';

import { useRef } from 'react';
import { gsap, useGSAP, MOTION_OK } from '@/components/motion/gsap';

const LETTERS = 'LenSync'.split('');

/**
 * The name, set as wide as the page, rising letter by letter out of the
 * footer's floor as you reach the bottom — scrubbed, so it answers the scroll
 * rather than playing at it. Hovering a letter lifts it and fills it with the
 * brand blue.
 */
export default function FooterWordmark() {
  const root = useRef(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        gsap.from('[data-letter]', {
          yPercent: 105,
          ease: 'none',
          stagger: 0.08,
          scrollTrigger: {
            trigger: root.current,
            start: 'top bottom',
            end: 'bottom bottom',
            scrub: 0.6,
          },
        });
      });
      return () => mm.revert();
    },
    { scope: root }
  );

  return (
    <div ref={root} aria-hidden className="select-none overflow-hidden">
      <div className="flex justify-center font-display text-[clamp(72px,21.5vw,340px)] font-bold leading-[0.78] tracking-[-0.05em] [font-stretch:112%]">
        {LETTERS.map((l, i) => (
          <span key={i} data-letter className="inline-block">
            <span className="inline-block text-primary-blue/10 transition-[color,transform] duration-300 hover:-translate-y-[4%] hover:text-primary-blue">
              {l}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
